import { createTransform } from 'redux-persist'
import sessionStorage from 'redux-persist/lib/storage/session'

import type { RunReportSliceState } from './api/RunReport/RunReport.slice'

const subjectInfoTransform = createTransform<
  RunReportSliceState['subjectInfo'],
  Omit<RunReportSliceState['subjectInfo'], 'image'>,
  RunReportSliceState,
  RunReportSliceState
>(
  (inbound) => {
    const { image: _image, ...rest } = inbound
    return rest
  },
  (outbound) => ({ ...outbound, image: null }),
  { whitelist: ['subjectInfo'] },
)

const consentTransform = createTransform<
  RunReportSliceState['consent'],
  Omit<RunReportSliceState['consent'], 'file'>,
  RunReportSliceState,
  RunReportSliceState
>(
  (inbound) => {
    const { file: _file, ...rest } = inbound
    return rest
  },
  (outbound) => ({ ...outbound, file: '' }),
  { whitelist: ['consent'] },
)

export const runReportPersistConfig = {
  key: 'wecheck.runReport.v1',
  storage: sessionStorage,
  version: 1,
  transforms: [subjectInfoTransform, consentTransform],
}
